import { render } from "./redpacketView.vue?vue&type=template&id=9c76e27e"
import script from "./redpacketView.vue?vue&type=script&lang=js"
export * from "./redpacketView.vue?vue&type=script&lang=js"

import "./redpacketView.vue?vue&type=style&index=0&id=9c76e27e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__